import {
  getOffers,
  getOffersOpenKPI,
  getOffersArchivedKPI,
} from "@/data/offers";
import { OfferKpiType, OffersQueryParams, Offers } from "@/types/offers";
import { SerializableObject } from "@repo/next-shared/utils/nuqs-custom-parsers";

export function useOffersKpi(
  searchParams: Partial<OffersQueryParams>,
  kpiConfig: any,
  type: string,
  key: SerializableObject,
): any {
  return {
    queryKey: ["kpi", type, key],
    queryFn: () =>
      type === OfferKpiType.OPEN
        ? getOffersOpenKPI({ ...searchParams, status: "OPEN" })
        : getOffersArchivedKPI({ ...searchParams, status: "NOTOPEN" }),
    select: (data: any) => {
      return kpiConfig.map((item: any) => {
        const offerKpi = data?.offers?.find(
          (kpi: any) => kpi.type === item.type,
        );
        return {
          ...item,
          totalOffers: offerKpi?.totalOffers || 0,
          totalRevenue: offerKpi?.totalRevenue || 0,
        };
      });
    },
    staleTime: 100,
  };
}

export function useOffers(
  searchParams: Partial<OffersQueryParams>,
  key: SerializableObject,
  status: string,
): any {
  return {
    queryKey: ["offers", status, key],
    queryFn: () => getOffers(searchParams),
    staleTime: 100,
  };
}

export function useOffer(offerId: string): any {
  return {
    queryKey: ["offer", offerId],
    queryFn: () => getOffers({ offerId }),
    staleTime: 1000,
    select: (data: any) => {
      return data?.list?.find((offer: Offers) => offer.id === offerId);
    },
  };
}
